<section class="bg fillPrimary">
  <img class="logo" src="/assets/images/logo_eceos_white.svg" />
  <app-confirm-email-card
    [email]="email"
    [onLogin]="onLogin"
  ></app-confirm-email-card>
</section>
